<template>
    <div>
        桥接页面
        {{content}}
    </div>
</template>
<script>
    export default {
        name: "bridge",
        data(){
            return {
                content: null
            }
        },
        mounted(){
            // 监听本地存储是否发生变化，如果发生变化则向其他同源发出消息
            window.addEventListener('message',(e)=>{
                console.log('收到其他侧发来的消息==>设置本地storage', e)
                this.content = 'e=>' + e.data.type
                if(e.data.type === 'closeWindow') {
                    localStorage.setItem('closeWindow', e.data.data.token)
                }
            });
        }
    }
</script>

<style scoped>

</style>
